
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';

class InfoPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // example future state
      isOpen: false,
    };
  }

  render() {
    const { content, trigger, position, disabled, touchAsClicked } = this.props;

    // Wrap trigger with stopPropagation
    const wrappedTrigger = React.cloneElement(trigger, {
      onClick: (e) => {
        e.stopPropagation();
        if (trigger.props.onClick) {
          trigger.props.onClick(e);
        }
      },
    });

    // Wrap content with stopPropagation
    const wrappedContent = (
      <div onClick={e => e.stopPropagation()}>
        {content}
      </div>
    );

    return (
      <Popup
        size="mini"
        inverted
        basic
        content={wrappedContent}
        position={position}
        trigger={wrappedTrigger}
        disabled={disabled}
        on={touchAsClicked ? 'click' : ['hover', 'click']}
        offset={[0, 0]}
      />
    );
  }
}

// Optional: define default props
InfoPopup.defaultProps = {
  position: 'bottom center',
  touchAsClicked: false,
};

InfoPopup.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  position: PropTypes.string,
  trigger: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  // attempt workaround fix where some touch device
  // incorrectly registered the touch event as click event
  touchAsClicked: PropTypes.bool,
};

export default InfoPopup;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/Basic/UCBPopup.jsx